// Comisiones de las OTAs (7-oct-2026). «Lo que te llega» en la ficha de la reserva
// (components/Reservas/PayData.vue): total − comisión de la OTA − IVA de la comisión.
// Placeholders: {channel} nombre del canal, {rate} y {vat} porcentajes ya formateados,
// {base} y {amount} importes ya formateados, {unit} tipo de habitación.
export const otaNet = {
  title: "Lo que te llega",
  gross: "Total de la reserva",
  // Si arriba hay extras cobrados aparte, el total de arriba no es el que ve la OTA.
  grossOnChannel: "Total de la reserva en {channel}",
  // Reserva combinada: el neto es de esta línea, no del grupo.
  grossOfUnit: "Total de {unit}",
  commission: "Comisión y cargos de {channel} ({rate}\u00a0%)",
  commissionOfBase: "Comisión y cargos de {channel} ({rate}\u00a0% de {base})",
  commissionReal: "Comisión de {channel} (informada por el canal)",
  vat: "IVA de la comisión ({vat}\u00a0%)",
  net: "Te llega (aprox.)",
  howItWorks: "Cómo se calcula",
  infoEstimate: "Estimación con los porcentajes de «Comisiones de las OTAs» del alojamiento. La OTA puede transferir una cifra algo distinta (redondeos, promociones, cargos por pago).",
  infoBase: "La tasa turística y la fianza no pagan comisión.",
  infoReal: "La comisión la informó {channel} para esta reserva. El IVA de la comisión es una estimación con el porcentaje de «Comisiones de las OTAs», así que lo que te llega sigue siendo aproximado.",
  infoRealNoVat: "La comisión la informó {channel} para esta reserva. Aun así, la transferencia puede variar un poco (redondeos, cargos por pago).",
  airbnbNet: "Airbnb ya paga el importe neto: lo que ves es lo que te llega.",
  apart: "No incluye {amount} que cobras aparte: eso no pasa por {channel}.",
  theChannel: "la OTA",
};
